module.exports = __webpack_public_path__ + "img/win.70bacd73.png";